import { render } from "./OrderTime.vue?vue&type=template&id=70d530c3&scoped=true"
import script from "./OrderTime.vue?vue&type=script&lang=js"
export * from "./OrderTime.vue?vue&type=script&lang=js"

import "./OrderTime.vue?vue&type=style&index=0&id=70d530c3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d530c3"]])

export default __exports__